import dayjs from "dayjs";
import { DATE_FORMAT_DD_MM_YYYY_HH_mm } from "constants/DateConstant";
import i18n from "translations/i18n";
import { Trans } from "react-i18next";
import { formatPrice, getUserStatus } from "./formatters";
import { CURRENCY } from "../constants/DeliveryConstants";
import { reduce } from "lodash";
import { PAYMENT_METHOD_INVOICE } from "../constants/PaymentConstants";
import { GROWY } from "../constants/CompanyConstants";
import { DEFAULT_DELIVERY_LABEL_FALLBACK, RETAIL_DELIVERY_LABEL } from "../constants/OrderConstant";
import { applyCustomerPricingToProduct, calculateOrderPricing } from "./pricing";
import { NETHERLANDS_COUNTRY_CODE } from "../constants/PricingConstants";

export function getExcelExportData(rows) {
  return [
    {
      columns: [
        { title: "ID" },
        { title: "Bestelnummer" },
        { title: "Besteldatum" },
        { title: "Bezorgdatum" },
        { title: "Bedrijfsnaam" },
        { title: "Naam" },
        { title: "Email" },
        { title: "Status" },
        { title: "Bestelnotities" },
        { title: "Producten" },
        { title: "Korting" },
        { title: "Verzendkosten" },
        { title: "Totaalprijs" },
      ],
      data:
        rows.length > 0
          ? rows.map((row) => {
              let products = row.userShoppingCart;
              let productString = "";
              if (!!products) {
                products.forEach((product, index) => {
                  if (index !== products.length - 1)
                    productString += product.itemCount + "x " + product.productName + `(${product.productId}) \n`;
                  else productString += product.itemCount + "x " + product.productName + `(${product.productId})`;
                });
              }
              return [
                { value: row.id },
                { value: row.farmorderId },
                { value: dayjs(row.orderDateTime).format(DATE_FORMAT_DD_MM_YYYY_HH_mm) },
                { value: dayjs(row.farmorderDeliveryDate, "YYYY-MM-DD").format("DD-MM-YYYY") },
                { value: row.farmorderCustomerName },
                { value: row.farmorderUserFirstName + " " + row.farmorderUserLastName },
                { value: row.userEmail },
                { value: row.farmorderStatus },
                { value: row.farmorderComments },
                { value: productString },
                { value: row.customerDiscount + "%" },
                { value: !!row.shippingCost ? CURRENCY + formatPrice(parseFloat(row.shippingCost)) : "-" },
                { value: CURRENCY + formatPrice(row.totalAmount) },
              ];
            })
          : [],
    },
  ];
}

export function getOrderAverageExcelExportData(exportData, simpleProductName = false) {
  return [
    {
      columns: [
        { title: "Product" },
        { title: "Maandag" },
        { title: "Dinsdag" },
        { title: "Woensdag" },
        { title: "Donderdag" },
        { title: "Vrijdag" },
        { title: "Zaterdag" },
        { title: "Zondag" },
        { title: "Totaal" },
        { title: "" },
        { title: "Start" },
        { title: "Eind" },
      ],
      data:
        !!exportData && exportData.products.length > 0
          ? exportData.products.map((item, index) => {
              const productName = simpleProductName ? item.name : `${item.name} (${item.id})`;
              const total =
                Math.round(
                  (item.orders[1] / exportData.daysInPeriod[1] +
                    item.orders[2] / exportData.daysInPeriod[2] +
                    item.orders[3] / exportData.daysInPeriod[3] +
                    item.orders[4] / exportData.daysInPeriod[4] +
                    item.orders[5] / exportData.daysInPeriod[5] +
                    item.orders[6] / exportData.daysInPeriod[6] +
                    item.orders[0] / exportData.daysInPeriod[0]) *
                    100,
                ) / 100;
              return [
                { value: productName },
                { value: Math.round((item.orders[1] / exportData.daysInPeriod[1]) * 100) / 100 },
                { value: Math.round((item.orders[2] / exportData.daysInPeriod[2]) * 100) / 100 },
                { value: Math.round((item.orders[3] / exportData.daysInPeriod[3]) * 100) / 100 },
                { value: Math.round((item.orders[4] / exportData.daysInPeriod[4]) * 100) / 100 },
                { value: Math.round((item.orders[5] / exportData.daysInPeriod[5]) * 100) / 100 },
                { value: Math.round((item.orders[6] / exportData.daysInPeriod[6]) * 100) / 100 },
                { value: Math.round((item.orders[0] / exportData.daysInPeriod[0]) * 100) / 100 },
                { value: total },
                { value: "" },
                { value: index === 0 ? dayjs.unix(exportData.start).format("DD-MM-YYYY") : "" },
                { value: index === 0 ? dayjs.unix(exportData.end).format("DD-MM-YYYY") : "" },
              ];
            })
          : [],
    },
  ];
}

export function getOrderTotalExcelExportData(exportData, simpleProductName = false) {
  return [
    {
      columns: [
        { title: "Product" },
        { title: "Maandag" },
        { title: "Dinsdag" },
        { title: "Woensdag" },
        { title: "Donderdag" },
        { title: "Vrijdag" },
        { title: "Zaterdag" },
        { title: "Zondag" },
        { title: "Totaal" },
        { title: "" },
        { title: "Start" },
        { title: "Eind" },
      ],
      data:
        !!exportData && exportData.products.length > 0
          ? exportData.products.map((item, index) => {
              const productName = simpleProductName ? item.name : `${item.name} (${item.id})`;
              const total =
                Math.round(
                  reduce(
                    item.orders,
                    function (sum, n) {
                      return sum + n;
                    },
                    0,
                  ) * 100,
                ) / 100;
              return [
                { value: productName },
                { value: item.orders[1] },
                { value: item.orders[2] },
                { value: item.orders[3] },
                { value: item.orders[4] },
                { value: item.orders[5] },
                { value: item.orders[6] },
                { value: item.orders[0] },
                { value: total },
                { value: "" },
                { value: index === 0 ? dayjs.unix(exportData.start).format("DD-MM-YYYY") : "" },
                { value: index === 0 ? dayjs.unix(exportData.end).format("DD-MM-YYYY") : "" },
              ];
            })
          : [],
    },
  ];
}

export function getOrderAverageRevenueExcelExportData(exportData, simpleProductName = false) {
  return [
    {
      columns: [
        { title: "Product" },
        { title: "Maandag" },
        { title: "Dinsdag" },
        { title: "Woensdag" },
        { title: "Donderdag" },
        { title: "Vrijdag" },
        { title: "Zaterdag" },
        { title: "Zondag" },
        { title: "Totaal" },
        { title: "" },
        { title: "Start" },
        { title: "Eind" },
      ],
      data:
        !!exportData && exportData.products.length > 0
          ? exportData.products.map((item, index) => {
              const productName = simpleProductName ? item.name : `${item.name} (${item.id})`;
              const totalRevenue =
                Math.round(
                  (item.revenue[1] / exportData.daysInPeriod[1] +
                    item.revenue[2] / exportData.daysInPeriod[2] +
                    item.revenue[3] / exportData.daysInPeriod[3] +
                    item.revenue[4] / exportData.daysInPeriod[4] +
                    item.revenue[5] / exportData.daysInPeriod[5] +
                    item.revenue[6] / exportData.daysInPeriod[6] +
                    item.revenue[0] / exportData.daysInPeriod[0]) *
                    100,
                ) / 100;
              return [
                { value: productName },
                { value: "€ " + Math.round((item.revenue[1] / exportData.daysInPeriod[1]) * 100) / 100 },
                { value: "€ " + Math.round((item.revenue[2] / exportData.daysInPeriod[2]) * 100) / 100 },
                { value: "€ " + Math.round((item.revenue[3] / exportData.daysInPeriod[3]) * 100) / 100 },
                { value: "€ " + Math.round((item.revenue[4] / exportData.daysInPeriod[4]) * 100) / 100 },
                { value: "€ " + Math.round((item.revenue[5] / exportData.daysInPeriod[5]) * 100) / 100 },
                { value: "€ " + Math.round((item.revenue[6] / exportData.daysInPeriod[6]) * 100) / 100 },
                { value: "€ " + Math.round((item.revenue[0] / exportData.daysInPeriod[0]) * 100) / 100 },
                { value: "€ " + totalRevenue },
                { value: "" },
                { value: index === 0 ? dayjs.unix(exportData.start).format("DD-MM-YYYY") : "" },
                { value: index === 0 ? dayjs.unix(exportData.end).format("DD-MM-YYYY") : "" },
              ];
            })
          : [],
    },
  ];
}

export function getOrderTotalRevenueExcelExportData(exportData, simpleProductName = false) {
  return [
    {
      columns: [
        { title: "Product" },
        { title: "Maandag" },
        { title: "Dinsdag" },
        { title: "Woensdag" },
        { title: "Donderdag" },
        { title: "Vrijdag" },
        { title: "Zaterdag" },
        { title: "Zondag" },
        { title: "Totaal" },
        { title: "" },
        { title: "Start" },
        { title: "Eind" },
      ],
      data:
        !!exportData && exportData.products.length > 0
          ? exportData.products.map((item, index) => {
              const productName = simpleProductName ? item.name : `${item.name} (${item.id})`;
              const totalRevenue =
                Math.round(
                  reduce(
                    item.revenue,
                    function (sum, n) {
                      return sum + n;
                    },
                    0,
                  ) * 100,
                ) / 100;
              return [
                { value: productName },
                { value: "€ " + Math.round(item.revenue[1] * 100) / 100 },
                { value: "€ " + Math.round(item.revenue[2] * 100) / 100 },
                { value: "€ " + Math.round(item.revenue[3] * 100) / 100 },
                { value: "€ " + Math.round(item.revenue[4] * 100) / 100 },
                { value: "€ " + Math.round(item.revenue[5] * 100) / 100 },
                { value: "€ " + Math.round(item.revenue[6] * 100) / 100 },
                { value: "€ " + Math.round(item.revenue[0] * 100) / 100 },
                { value: "€ " + totalRevenue },
                { value: "" },
                { value: index === 0 ? dayjs.unix(exportData.start).format("DD-MM-YYYY") : "" },
                { value: index === 0 ? dayjs.unix(exportData.end).format("DD-MM-YYYY") : "" },
              ];
            })
          : [],
    },
  ];
}

export function getCustomerExcelExportData(customers, { getPriceListById } = {}) {

  return [
    {
      columns: [
        { title: "Klantnummer" },
        { title: "Bedrijfsnaam" },
        { title: "Exact code" },
        { title: "Status" },
        { title: "Klanttype" },
        { title: "Email" },
        { title: "Factuur email" },
        { title: "Telefoonnummer" },
        { title: "KvK-nummer" },
        { title: "Btw-nummer" },
        { title: "Afleveradres" },
        { title: "Afleverland" },
        { title: "Factuuradres" },
        { title: "Factuurland" },
        { title: "Betaalmethode" },
        { title: "Kredietlimiet" },
        { title: "Prijslijst" },
        { title: "Bezorgdagen" },
        { title: "Bezorglabel" },
        { title: "Bezorgkosten" },
        { title: "Gratis bezorging vanaf" },
        { title: "Bezorgnotities" },
        { title: "GLN" },
        { title: "GLN afleveradres" },
        { title: "Klantkorting" },
        { title: "Aantal gebruikers" },
      ],
      data:
        customers.length > 0
          ? customers.map((customer) => {
              return [
                { value: customer.customerId || "" },
                { value: customer.customerName || "" },
                { value: customer.exactAccountCode || "" },
                { value: customer.status ? getUserStatus(customer.status) : "" },
                { value: customer.marketingCode || "" },
                { value: customer.customerEmail || "-" },
                { value: customer.invoiceEmail || "" },
                { value: customer.customerPhone || "-" },
                { value: customer.kvkNumber || "" },
                { value: customer.taxNumber || "" },
                { value: customer.customerAddress || "" },
                { value: customer.country || "" },
                { value: customer.customerBillingAddress || "" },
                // Same fallback as Exact (InvoiceCountry || DeliveryCountry)
                { value: customer.invoiceCountry || customer.country || "" },
                { value: customer.paymentMethod || "" },
                { value: customer.creditLimit ?? "" },
                {
                  value: customer.priceListId
                    ? getPriceListById?.(customer.priceListId)?.name || customer.priceListId
                    : "",
                },
                { value: customer.customerDeliveryDays || "" },
                { value: customer.deliveryLabel || "" },
                { value: customer.deliveryCost ?? "" },
                { value: customer.deliveryCostThreshold ?? "" },
                { value: customer.deliveryNotes || "" },
                { value: customer.customerGln || "" },
                { value: customer.customerDeliveryGln || "" },
                { value: customer.customerDiscount ? customer.customerDiscount + "%" : "0%" },
                { value: customer.customerUsers.length || 0 },
              ];
            })
          : [],
    },
  ];
}

export function getUserExcelExportData(users) {
  return [
    {
      columns: [
        { title: "Gebruiker" },
        { title: "Bedrijfsnaam" },
        { title: "Email" },
        { title: "Telefoonnummer" },
        { title: "Taal" },
        { title: "App versie" },
      ],
      data:
        users.length > 0
          ? users.map((user) => {
              return [
                { value: user.userFirstName + " " + user.userLastName || "" },
                { value: user.userCustomerName || "" },
                { value: user.userEmail || "" },
                { value: user.userPhoneNumber || "-" },
                { value: user.userLanguage || "-" },
                { value: user.userAppVersion || "-" },
              ];
            })
          : [],
    },
  ];
}

export const getExcelImportErrorMessage = (error) => {
  return (
    <Trans
      i18nKey="notifications.excel_import_error"
      values={{
        column: error.column,
        row: error.row + 1,
        error: i18n.t(error.error),
      }}
    />
  );
};

export const parseExcelOrders = (
  orders,
  customers,
  products,
  users,
  profile,
  auth,
  companyFilter,
  priceLists,
  countriesMap = null,
) => {
  const finalOrders = [];
  const skippedOrders = [];

  orders.forEach((order) => {
    const reasons = [];
    const isGrowy = companyFilter === GROWY;

    // Find customer in database
    const dbCustomer = customers.find((c) => c.customerName.toLowerCase() === order.customer.toLowerCase());

    if (!dbCustomer) {
      reasons.push(`Customer "${order.customer}" not found in database`);
      skippedOrders.push({ order, reasons });
      return;
    }

    // Find user in database
    let user = null;
    if (order.userName) {
      const [firstName, ...lastNameParts] = order.userName.split(" ");
      const lastName = lastNameParts.join(" ");
      user = users.find(
        (u) =>
          u.userFirstName?.toLowerCase() === firstName.toLowerCase() &&
          u.userLastName?.toLowerCase() === lastName.toLowerCase(),
      );

      if (!user) {
        reasons.push(`User "${order.userName}" not found in database`);
      }
    }

    // Use profile user if no user found
    if (!user) {
      user = {
        userId: profile.userId,
        userFirstName: profile.userFirstName,
        userLastName: profile.userLastName,
        userEmail: profile.userEmail,
      };
    }

    // Validate delivery date
    if (!order.deliveryDate) {
      reasons.push("Delivery date is required");
      skippedOrders.push({ order, reasons });
      return;
    }

    // Map products from order
    const userShoppingCart = [];
    let allProductsFound = true;

    order.products.forEach((orderProduct) => {
      const dbProduct = products.find(
        (p) =>
          p.productName.toLowerCase() === orderProduct.product.toLowerCase() || p.productId === orderProduct.product,
      );

      if (!dbProduct) {
        reasons.push(`Product "${orderProduct.product}" not found in database`);
        allProductsFound = false;
        return;
      }

      const productPrice = applyCustomerPricingToProduct(dbProduct, dbCustomer, priceLists, countriesMap);

      userShoppingCart.push({
        itemCount: orderProduct.quantity,
        productGroup: dbProduct.productGroup,
        productId: dbProduct.productId,
        productName: dbProduct.productName,
        productPrice: productPrice,
        size: dbProduct.size,
      });
    });

    if (!allProductsFound) {
      skippedOrders.push({ order, reasons });
      return;
    }

    // Calculate pricing
    const pricing = calculateOrderPricing(
      userShoppingCart,
      dbCustomer,
      isGrowy ? RETAIL_DELIVERY_LABEL : dbCustomer?.deliveryLabel || DEFAULT_DELIVERY_LABEL_FALLBACK,
      products,
      true,
      null,
      priceLists,
      countriesMap,
    );

    const formattedSubTotal = parseFloat(pricing.subtotal.toFixed(2));
    const formattedTotalPrice = parseFloat(pricing.total.toFixed(2));
    const tax = parseFloat(pricing.tax.toFixed(2));

    // Get customer country settings
    const customerCountry = dbCustomer.country || NETHERLANDS_COUNTRY_CODE;
    const countrySettings = countriesMap?.[customerCountry];
    const deliveryCostThreshold = countrySettings?.delivery?.deliveryCostThreshold || 50;

    finalOrders.push({
      crates: 1,
      createdBy: "CMS Excel import - " + auth.email,
      customerDiscount: 0,
      deliveryBy: isGrowy ? "Growy" : "Chef's Farm",
      deliveryCostThreshold,
      deliveryLabel: isGrowy
        ? dbCustomer?.deliveryLabel || RETAIL_DELIVERY_LABEL
        : dbCustomer?.deliveryLabel || DEFAULT_DELIVERY_LABEL_FALLBACK,
      deliveryNotes: "",
      deliveryTime: "",
      deliveryTimeCharge: 0,
      farmorderComments: "",
      farmorderCustomerId: dbCustomer?.id || "",
      farmorderCustomerName: dbCustomer?.customerName,
      farmorderDateTime: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
      farmorderDeliveryDate: dayjs(order.deliveryDate, "DD-MM-YYYY").format("YYYY-MM-DD"),
      farmorderId: "",
      farmorderRegion: dbCustomer.customerRegion,
      farmorderStatus: "submitted",
      farmorderUserFirstName: isGrowy ? "" : user.userFirstName || "",
      farmorderUserId: isGrowy ? "" : user.userId || "",
      farmorderUserLastName: isGrowy ? "" : user.userLastName || "",
      invoiceAdditionalCosts: 0,
      orderDateTime: dayjs().unix() * 1000,
      packed: false,
      paymentMethod: PAYMENT_METHOD_INVOICE,
      reference: order.reference,
      shippingCost: pricing.shippingCost.toString(),
      subTotalAmount: formattedSubTotal,
      subTotalWithoutDiscount: formattedTotalPrice,
      tax,
      totalAmount: formattedTotalPrice,
      userEmail: user.userEmail,
      userLanguage: "nl",
      userShoppingCart,
    });

    if (reasons.length > 0) {
      skippedOrders.push({ order, reasons });
    }
  });

  return { finalOrders, skippedOrders };
};
